if (!customElements.get('collection-faq')) {
  class CollectionFaq extends HTMLElement {
    constructor() {
      super();

      this.source = null;
      this.intro = null;
      this.list = null;
      this.singleOpen = true;
      this.openFirst = false;

      this.handleToggle = this.handleToggle.bind(this);
    }

    connectedCallback() {
      this.source = this.querySelector('[data-faq-source]');
      this.intro = this.querySelector('[data-faq-intro]');
      this.list = this.querySelector('[data-faq-list]');

      if (!this.source || !this.list) return;

      this.singleOpen = this.dataset.singleOpen !== 'false';
      this.openFirst = this.dataset.openFirst === 'true';

      this.buildAccordion();
    }

    buildAccordion() {
      const richTextRoot =
        this.source.querySelector('.metafield-rich_text_field') || this.source;

      const nodes = Array.from(richTextRoot.children);
      const parsed = this.parseNodes(nodes);

      if (!parsed.items.length) {
        return;
      }

      if (this.intro && parsed.introNodes.length) {
        parsed.introNodes.forEach((node) => {
          this.intro.appendChild(node);
        });
        this.intro.hidden = false;
      }

      parsed.items.forEach((item, index) => {
        const details = document.createElement('details');
        details.className = 'collection-faq__item';

        const summary = document.createElement('summary');
        summary.className = 'collection-faq__question';

        const questionText = document.createElement('span');
        questionText.className = 'collection-faq__question-text';
        questionText.innerHTML = item.questionHtml;

        const icon = document.createElement('span');
        icon.className = 'collection-faq__icon';
        icon.setAttribute('aria-hidden', 'true');

        const answer = document.createElement('div');
        answer.className = 'collection-faq__answer rte';

        item.answerNodes.forEach((node) => {
          answer.appendChild(node);
        });

        summary.appendChild(questionText);
        summary.appendChild(icon);
        details.appendChild(summary);
        details.appendChild(answer);

        if (this.openFirst && index === 0) {
          details.open = true;
        }

        if (this.singleOpen) {
          details.addEventListener('toggle', this.handleToggle);
        }

        this.list.appendChild(details);
      });

      this.source.hidden = true;
      this.list.hidden = false;
      this.classList.add('is-enhanced');
    }

    parseNodes(nodes) {
      const items = [];
      const introNodes = [];
      let currentItem = null;
      let answerStarted = false;

      nodes.forEach((node) => {
        const text = this.normalizeText(node.textContent);
        const questionMatch = text.match(this.questionPattern());
        const answerMatch = text.match(this.answerPattern());

        if (questionMatch) {
          this.finishItem(items, currentItem);

          const questionNode = node.cloneNode(true);
          this.removeLeadingPrefix(questionNode, this.questionPattern());

          currentItem = {
            questionHtml: questionNode.innerHTML.trim(),
            answerNodes: []
          };
          answerStarted = false;
          return;
        }

        if (answerMatch && currentItem) {
          const answerNode = node.cloneNode(true);
          this.removeLeadingPrefix(answerNode, this.answerPattern());

          if (this.normalizeText(answerNode.textContent)) {
            currentItem.answerNodes.push(answerNode);
          }

          answerStarted = true;
          return;
        }

        if (currentItem && answerStarted) {
          currentItem.answerNodes.push(node.cloneNode(true));
          return;
        }

        if (!currentItem && !this.isFaqHeading(text)) {
          introNodes.push(node.cloneNode(true));
        }
      });

      this.finishItem(items, currentItem);

      return { items, introNodes };
    }

    finishItem(items, item) {
      if (!item) return;

      const question = this.normalizeText(
        this.htmlToText(item.questionHtml)
      );

      const hasAnswer = item.answerNodes.some((node) =>
        Boolean(this.normalizeText(node.textContent))
      );

      if (question && hasAnswer) {
        items.push(item);
      }
    }

    questionPattern() {
      return /^(?:Q(?:uestion)?\s*\d*|问(?:题)?\s*\d*)\s*[:：.\-–—]?\s*/i;
    }

    answerPattern() {
      return /^(?:A(?:nswer)?|答(?:案)?)\s*\d*\s*[:：.\-–—]?\s*/i;
    }

    removeLeadingPrefix(element, pattern) {
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT
      );

      let textNode = walker.nextNode();

      while (textNode) {
        if (this.normalizeText(textNode.nodeValue)) {
          textNode.nodeValue = textNode.nodeValue.replace(pattern, '');
          break;
        }
        textNode = walker.nextNode();
      }
    }

    isFaqHeading(text) {
      const normalized = text
        .toLowerCase()
        .replace(/[\s:：.\-–—]/g, '');

      return [
        'faq',
        'faqs',
        'frequentlyaskedquestions',
        '常见问题',
        '常见问答'
      ].includes(normalized);
    }

    normalizeText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    htmlToText(html) {
      const template = document.createElement('template');
      template.innerHTML = html;
      return template.content.textContent || '';
    }

    handleToggle(event) {
      const openedItem = event.currentTarget;

      if (!openedItem.open) return;

      this.querySelectorAll('.collection-faq__item[open]').forEach((item) => {
        if (item !== openedItem) {
          item.open = false;
        }
      });
    }
  }

  customElements.define('collection-faq', CollectionFaq);
}
